<era-panel>
  <era-panel-header>
    <era-title>
      <span title
            i18n>Devices</span>
    </era-title>
  </era-panel-header>

  <ml-list-lazy class="list-group w-100 h-100"
                data-testid="mdm-devices-list"
                [dataSource]="dataSource"
                [columnDefinitions]="columnDefs"
                (gridReady)="onGridReady($event)"
                [rowHeight]="60"
                domLayout="normal"
                rowNodeIdProperty="udid">
  </ml-list-lazy>

</era-panel>